export default __webpack_public_path__ + "static/media/SackBasics.cef9255e.jpg";